import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core';
import { Link, ExtendedTheme, Avatar, InlineText } from 'neon-design-system';
import { getInitials } from '../../utils/string.utils';
import { useSecureFileUrl } from '../hooks/use-secure-file-url';
import { getPublisherUrl } from '../../utils/utils';
import { ChannelOwner } from '../../shared/types';

const useStyles = makeStyles((theme: ExtendedTheme) => createStyles({
	root: {
		display: 'flex',
		minHeight: 64,
		height: '100%',
		backgroundColor: theme.themeColors.blueGrey[700],
		borderRadius: 4,
		padding: theme.spacing(2)

	},
	details: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
		justifyContent: 'center',
		marginLeft: theme.spacing(2)
	},
	avatarContainer: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center'
	},
	avatar: {
		backgroundColor: theme.themeColors.blueGrey[500]
	},
	jobFunction: {
		marginTop: theme.spacing(0.5),
		paddingRight: theme.spacing(0.5),
		color: theme.themeColors.blueGrey[200]
	},
	phoneNumber: {
		marginTop: theme.spacing(0.5),
		paddingRight: theme.spacing(0.5),
		color: theme.themeColors.blueGrey[200],
		whiteSpace: 'nowrap'
	}
})
);

export interface ContributorProps {
	_id: string;
	name?: string;
	jobFunction?: string;
	className?: string;
	phone?: string;
}

export const Contributor = (props: ContributorProps) => {
	const classes = useStyles();
	const { name = '', jobFunction = '', _id, phone = '' } = props

	const imgLink = useSecureFileUrl('/contributor-profile-picture/' + window.encodeURIComponent(_id));

	const url = getPublisherUrl({type: 'contributor' as ChannelOwner, _id});
	const initials = getInitials(name);

	if (!name) return null;

	return (
		<div
			id={`article-page-contributor-${props.name}`}
			className={[classes.root, props.className].filter(Boolean).join(' ')}>
			<div className={classes.avatarContainer}>
				<Avatar customClass={classes.avatar} initials={initials} size="small" imageSrc={imgLink} />
			</div>
			<div className={classes.details}>
				<Link to={url}><strong>{name}</strong></Link>
				{(jobFunction || phone) &&
					<div>
						{
							jobFunction && (<InlineText className={classes.jobFunction} styleName="caption2"><strong>{jobFunction}</strong></InlineText>)
						}
						{
							// this trick is to force phone overflow correctly if both job and phone are long
							phone && (' ')
						}
						{
							phone && (<InlineText className={classes.phoneNumber} styleName="caption2">{phone}</InlineText>)
						}
					</div>
				}
			</div>
		</div>
	);
};

export default Contributor;
